import PerfectDiaperForBaby from '../../StoreCategoryPage/PerfectDiaperForBaby';
import WhyDiaperSafeCarousel from '../../StoreCategoryPage/WhyDiaperSafeCarousel';
import BannerGridCarousel from '../BannerGridCarousel';
import WaveGridCarousel from '../BannerGridCarousel/WaveGridCarousel';
import BannersGrid from '../BannersGrid';
import { BestSeller } from '../BestSeller/styled';

export default function BannerGeneralItemListing(props) {
  const {
    element,
    index,
    showPrice,
    showGoTop,
    scrollUp,
    newDiaperVersion,
    happiness,
    isForNewCdPage,
    showNewGridView,
    handleScroll,
    addProductToCart,
  } = props;
  switch (element?.headingAlignment) {
    case 'TOP':
      return element?.isHorizontalScrollable ? (
        <BannerGridCarousel banner={element} key={index} parentIndex={index} />
      ) : (
        <BannersGrid
          banner={element}
          key={index}
          parentIndex={index}
          newDiaperVersion={newDiaperVersion}
          happiness={happiness}
          isForNewCdPage={isForNewCdPage}
          showNewGridView={showNewGridView}
          handleScroll={handleScroll}
          addProductToCart={addProductToCart}
        />
      );

    case 'WAVE':
      return (
        <WaveGridCarousel banner={element} key={index} parentIndex={index} />
      );

    case 'CUSTOM':
      return (
        <PerfectDiaperForBaby
          banner={element}
          showGoTop={showGoTop}
          scrollUp={scrollUp}
          columnSize={element?.gridSize}
          newDiaperVersion={newDiaperVersion}
        />
      );
    case 'WAVECAROUSEL':
      return (
        <WhyDiaperSafeCarousel data={element} isForNewCdPage={isForNewCdPage} />
      );
    default:
      return (
        <BestSeller
          type={'banner'}
          data={element}
          showPrice={showPrice ? showPrice : true}
          key={index}
        />
      );
  }
}
